import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SucursalInformacionComercialMesList } from "./informacionPorMes/list";

type Entity = models.SucursalInformacionComercial;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un SucursalInformacionComercial
*/
export class SucursalInformacionComercialEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            Año: validation.required
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const titulo = "Información comercial del año " + value.Año;
        const InformacionComercialMes = getField(SucursalInformacionComercialMesList);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={validation.hasError(this.errors())} />]}
                
                onClose={this.onCerrar}
                title={titulo}
            >
            <Number field="Año" label="Año" />
            <InformacionComercialMes field="InformacionComercialMes" idInformacionComercial={value.IdRegistro}/>
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/informacioncomercial/edit.tsx